export default "<div class=\"horizontal-slider\" #container>\r\n  <ng-content></ng-content>\r\n</div>\r\n"